import { useAtom } from "jotai";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { INTERVIEW_PAGE_WIDTH_LIMITS } from "../constants";
import { baseAtom, toggleSticky } from "../stores/jotai/base";
import useWindowResize from "./useWindowResize";

const useInterviewPageOrgTreeVisibility = () => {
    const [isOrgTreeVisibleInInterviewPage, setIsOrgTreeVisibleInInterviewPage] =
        useState<boolean>(true);
    const [base, setBase] = useAtom(baseAtom);
    const location = useLocation();
    const [windowSize,setWindowSize]=useState(null);
    const isInInterviewPage = location.pathname?.includes("discovery");

    const onWindowResize = (innerWidth) => {
        if (
            isInInterviewPage &&
            innerWidth < INTERVIEW_PAGE_WIDTH_LIMITS.ORG_TREE
        ) {
            if (base.app.orgTreeOpen) {
                toggleSticky(setBase, false)
                // setOrgToggle(setBase, false);
            }
        } 
        setWindowSize(innerWidth);
        setIsOrgTreeVisibleInInterviewPage(true);
    };

    useWindowResize({
        onWindowResize,
    });

    return { isOrgTreeVisibleInInterviewPage,windowSize };
};

export default useInterviewPageOrgTreeVisibility;
